import Vue from 'vue'
import Router from 'vue-router'
import Path from '@/utilities/bid/enums/Path'
import auth from '@/middleware/auth'
import guest from '@/middleware/guest'
import permission from '@/middleware/permission'
import middlewarePipeline from '@/router/middlewarePipeline'
import { ServiceEnum, PermissionRules } from '@/utilities/auth/permission/enums/PermissionEnum'
import { RouteConfigType } from '@/router/types/RouteConfigType'
// @ts-ignore
import store from '@/store'

Vue.use(Router)

const routes: Array<RouteConfigType> = [
  {
    name: 'Login',
    path: Path.LOGIN,
    // @ts-ignore
    component: () => import(/* webpackChunkName: "registration" */ '@/views/dashboard/Login'),
    props: true,
    meta: {
      middleware: [guest],
    },
  },
  {
    path: Path.ROOT,
    // @ts-ignore
    component: () => import(/* webpackChunkName: "index" */ '@/views/dashboard/Index'),
    props: true,
    meta: {
      requiresAuth: true,
      middleware: [auth],
    },
    children: [
      // Dashboard
      {
        name: 'Dashboard',
        path: '',
        // @ts-ignore
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Dashboard'),
        props: true,
        meta: {
          description: 'List of our servers',
          requiresAuth: true,
          middleware: [auth],
        },
      },
      // Pages
      {
        name: 'Bids',
        path: Path.SALES_BIDS,
        // @ts-ignore
        component: () => import('@/views/dashboard/pages/bids/Bid'),
        props: true,
        children: [
          {
            // @todo Later it can be removed
            name: 'Redirect to Bid Summary',
            path: `${Path.SALES_BIDS}/summary`,
            redirect: { name: 'Bid Summary' },
            props: true,
          },
          {
            name: 'Bid Summary',
            path: Path.SALES_BIDS_SUMMARY,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/BidSummary'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'No Bid',
            path: Path.SALES_NO_BIDS_SUMMARY,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/inactive/Summary.vue'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Bid Register',
            path: Path.SALES_BIDS_REGISTER,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/BidRegister'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Bid Decision',
            path: Path.SALES_BIDS_DECISION,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/BidDecision'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Bid Decision - Director Approval',
            path: Path.SALES_BIDS_DECISION_DIRECTOR_APPROVAL,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/BidDirectorApproval'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Bid Specification',
            path: `${Path.SALES_BIDS_SPEC}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/BidSpecification'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'No Bid Specification',
            path: `${Path.SALES_NO_BIDS_SPEC}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/inactive/Specification.vue'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Bid Equipments',
            path: `${Path.SALES_BIDS_EQUIPMENT}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/BidEquipment'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'No Bid Equipments',
            path: `${Path.SALES_NO_BIDS_EQUIPMENT}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/inactive/Equipment'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Bid Paperwork',
            path: `${Path.SALES_BIDS_PAPERWORK}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/BidPaperwork'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'No Bid Paperwork',
            path: `${Path.SALES_NO_BIDS_PAPERWORK}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/inactive/Paperwork'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Bid Costs Summary',
            path: `${Path.SALES_BIDS_COST}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/BidCost'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              permissions: [PermissionRules.canSubmitBid],
              middleware: [auth, permission],
            },
          },
          {
            name: 'Bid Costs History Summary',
            path: `${Path.SALES_BIDS_COST}/:bidNumber/:id`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/bids/BidHistoryCost'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SALES,
              permissions: [PermissionRules.canSubmitBid],
              middleware: [auth, permission],
            },
          },
        ],
      },
      {
        path: Path.PROJECTS,
        // @ts-ignore
        component: () => import('@/views/dashboard/pages/projects/Index'),
        props: true,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            name: 'Project Summary',
            path: Path.PROJECTS_SUMMARY,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/projects/live/ProjectSummary.vue'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.PROJECTS,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Project Completed',
            path: Path.PROJECTS_COMPLETED,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/projects/completed/ProjectSummary.vue'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.PROJECTS,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Project Cancelled',
            path: Path.PROJECTS_CANCELLED,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/projects/cancelled/ProjectSummary.vue'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.PROJECTS,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Project Sites Specification',
            path: `${Path.PROJECTS_SPEC}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/projects/ProjectSpecification'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.PROJECTS,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Project Equipments',
            path: `${Path.PROJECTS_EQUIPMENT}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/projects/ProjectEquipment'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.PROJECTS,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Project Paperwork',
            path: `${Path.PROJECTS_PAPERWORK}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/projects/ProjectPaperwork'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.PROJECTS,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Project Overview',
            path: `${Path.PROJECTS_OVERVIEW}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/projects/live/ProjectOverview.vue'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.PROJECTS,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Project Cancelled Overview',
            path: `${Path.PROJECTS_CANCELLED_OVERVIEW}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/projects/cancelled/ProjectOverview.vue'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.PROJECTS,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Project Costings',
            path: `${Path.PROJECTS_COST}/:bidNumber/:record`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/projects/ProjectCostings'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.PROJECTS,
              middleware: [auth, permission],
            },
          },
        ],
      },
      {
        path: Path.FINANCES,
        // @ts-ignore
        component: () => import('@/views/dashboard/pages/finances/Index'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
        children: [
          {
            name: 'Wip Summary',
            path: Path.FINANCES_SUMMARY,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/finances/WipSummary'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.FINANCES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Unallocated Project Summary',
            path: `${Path.FINANCES_PROJECTS_UNALLOCATED}/:year?`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/finances/projects/unallocated/Summary.vue'),
            props: route => ({
              year: route.params?.year ? +route.params.year : null,
            }),
            beforeEnter: (to, _, next) => {
              return to.params?.year && !Number.isInteger(+to.params.year) ? next(Path.FINANCES_PROJECTS_UNALLOCATED) : next()
            },
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.FINANCES,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Unallocated Project Overview',
            path: `${Path.FINANCES_PROJECTS_UNALLOCATED_OVERVIEW}/:bidNumber`,
            // @ts-ignore
            component: () => import('@/views/dashboard/pages/finances/projects/unallocated/Overview.vue'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.PROJECTS,
              middleware: [auth, permission],
            },
          },
        ],
      },
      {
        path: Path.SITES,
        // @ts-ignore
        component: () => import('@/views/dashboard/pages/sites/Index'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
        children: [
          {
            name: 'Site',
            path: 'site',
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SITES,
              middleware: [auth, permission],
            },
          },
        ],
      },
      {
        name: 'Timesheet Entry',
        path: Path.TIMESHEETS_ENTRY,
        // @ts-ignore
        component: () => import('@/views/dashboard/pages/timesheets/TimesheetsEntry'),
        props: true,
        meta: {
          requiresAuth: true,
          serviceName: ServiceEnum.TIMESHEETS,
          middleware: [auth, permission],
        },
      },

      {
        name: 'Timesheet Summary',
        path: Path.TIMESHEETS_SUMMARY,
        // @ts-ignore
        component: () => import('@/components/pages/TimesheetsSummary'),
        props: true,
        meta: {
          requiresAuth: true,
          serviceName: ServiceEnum.TIMESHEETS,
          middleware: [auth, permission],
        },
      },

      {
        name: 'Timesheet Approval',
        path: Path.TIMESHEETS_APPROVAL,
        // @ts-ignore
        component: () => import('@/views/dashboard/pages/timesheets/TimesheetsApproval'),
        props: true,
        meta: {
          requiresAuth: true,
          serviceName: ServiceEnum.TIMESHEETS,
          middleware: [auth, permission],
        },
      },
      {
        path: Path.TRAININGS,
        // @ts-ignore
        component: () => import('@/views/dashboard/pages/trainings/Index'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
        children: [
          {
            name: 'Trainings',
            path: 'training',
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.TRAININGS,
              middleware: [auth, permission],
            },
          },
        ],
      },
      {
        path: Path.DOCUMENTS,
        // @ts-ignore
        component: () => import('@/views/dashboard/pages/documents/Index'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
        children: [
          {
            name: 'Documents',
            path: 'document',
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.DOCUMENTS,
              middleware: [auth, permission],
            },
          },
        ],
      },
      {
        name: 'System Adjustment',
        path: Path.ADJUSTMENT,
        // @ts-ignore
        component: () => import(/* webpackChunkName: "adjustment" */ '@/views/dashboard/pages/adjustment/Index'),
        props: true,
        redirect: Path.ADJUSTMENT_PERMISSION,
        meta: {
          requiresAuth: true,
          serviceName: ServiceEnum.SYSTEM_ADJUSTMENT,
          middleware: [auth, permission],
        },
        children: [
          {
            name: 'Permission',
            path: Path.ADJUSTMENT_PERMISSION,
            // @ts-ignore
            component: () => import(/* webpackChunkName: "adjustment" */ '@/views/dashboard/pages/adjustment/permission/Summary'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SYSTEM_ADJUSTMENT,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Roles',
            path: Path.ADJUSTMENT_ROLE,
            // @ts-ignore
            component: () => import(/* webpackChunkName: "adjustment" */ '@/views/dashboard/pages/adjustment/role/Role'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SYSTEM_ADJUSTMENT,
              middleware: [auth, permission],
            },
          },
          {
            name: 'Monday.com',
            path: Path.ADJUSTMENT_MONDAY,
            // @ts-ignore
            component: () => import(/* webpackChunkName: "adjustment" */ '@/views/dashboard/pages/adjustment/monday/Monday'),
            props: true,
            meta: {
              requiresAuth: true,
              serviceName: ServiceEnum.SYSTEM_ADJUSTMENT,
              middleware: [auth, permission],
            },
          },
        ],
      },
      // Pages
      {
        name: 'User Profile',
        path: '/pages/user',
        // @ts-ignore
        component: () => import('@/views/dashboard/pages/UserProfile'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
      },
      {
        name: 'Notifications',
        path: '/components/notifications',
        // @ts-ignore
        component: () => import('@/views/dashboard/component/Notifications'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
      },
      {
        name: 'Icons',
        path: '/components/icons',
        // @ts-ignore
        component: () => import('@/views/dashboard/component/Icons'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
      },
      {
        name: 'Typography',
        path: '/components/typography',
        // @ts-ignore
        component: () => import('@/views/dashboard/component/Typography'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
      },
      // Tables
      {
        name: 'Regular Tables',
        path: '/tables/regular-tables',
        // @ts-ignore
        component: () => import('@/views/dashboard/tables/RegularTables'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
      },
      // Maps
      {
        name: 'Google Maps',
        path: '/maps/google-maps',
        // @ts-ignore
        component: () => import('@/views/dashboard/maps/GoogleMaps'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
      },
      // Upgrade
      {
        name: 'Upgrade',
        path: '/upgrade',
        // @ts-ignore
        component: () => import('@/views/dashboard/Upgrade'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
      },
      {
        // not found handler
        path: '*',
        // @ts-ignore
        component: () => import('@/views/dashboard/404'),
        props: true,
        meta: {
          requiresAuth: true,
          middleware: [auth],
        },
      },
    ],
  },
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkExactActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    return (
      savedPosition || {
        x: 0,
        y: 0,
      }
    )
  },
})

router.beforeEach((to, from, next) => {
  if (!to.meta?.middleware && !to.meta?.requiresAuth) {
    return next(Path.LOGIN)
  }

  const middleware = to.meta?.middleware

  const context = {
    to,
    from,
    next,
    store,
  }

  return middleware[0]({ ...context, next: middlewarePipeline(context, middleware, 1) })
})

export default router
